import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import withRouter from "../hooks/withRouter";
import { Home } from "../pages/home";
import { Socialicons } from "../components/socialicons";
import { CSSTransition, TransitionGroup } from "react-transition-group";

// Lazy load heavy components
const Portfolio = lazy(() => import("../pages/portfolio").then(m => ({ default: m.Portfolio })));
const ContactUs = lazy(() => import("../pages/contact").then(m => ({ default: m.ContactUs })));
const About = lazy(() => import("../pages/about").then(m => ({ default: m.About })));
const Card = lazy(() => import("../pages/card").then(m => ({ default: m.Card })));
const Yahoo2 = lazy(() => import("../pages/yahoo2").then(m => ({ default: m.Yahoo2 })));
const Vis81 = lazy(() => import("../pages/vis81").then(m => ({ default: m.Vis81 })));
const Babylon = lazy(() => import("../pages/babylon").then(m => ({ default: m.Babylon })));
const GaussianSplats = lazy(() => import("../pages/gaussianSplats").then(m => ({ default: m.GaussianSplats })));
const Nowhere = lazy(() => import("../pages/nowhere").then(m => ({ default: m.Nowhere })));
const Resume = lazy(() => import("../pages/resume/index.tsx"));

const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    color: 'var(--text-color)'
  }}>
    Loading...
  </div>
);

const AnimatedRoutes = withRouter(({ location }) => (
  <TransitionGroup>
    <CSSTransition
      key={location.key}
      timeout={{
        enter: 400,
        exit: 400,
      }}
      classNames="page"
      unmountOnExit
    >
      <Suspense fallback={<LoadingFallback />}>
        <Routes location={location}>
          <Route exact path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/yahoo" element={<Yahoo2 />} />
          <Route path="/vis81" element={<Vis81 />} />
          <Route path="/card" element={<Card />} />
          <Route path="/babylon" element={<Babylon />} />
          <Route path="/gaussianSplats" element={<GaussianSplats />} />
          <Route path="/nowhere" element={<Nowhere />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
    </CSSTransition>
  </TransitionGroup>
));

function AppRoutes() {
  return (
    <div className="s_c">
      <AnimatedRoutes />
      {window.location.pathname !== "/card" && (<Socialicons />)}
    </div>
  );
}

export default AppRoutes;
